import { render, staticRenderFns } from "./planEditor.vue?vue&type=template&id=0fca11a4&scoped=true&"
import script from "./planEditor.vue?vue&type=script&lang=js&"
export * from "./planEditor.vue?vue&type=script&lang=js&"
import style0 from "./planEditor.vue?vue&type=style&index=0&id=0fca11a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca11a4",
  null
  
)

export default component.exports